var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7773_5248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 16.4999C12.418 16.4999 15.9998 12.9182 15.9998 8.49988C15.9998 4.0816 12.418 0.499878 7.99976 0.499878C3.58148 0.499878 -0.000244141 4.0816 -0.000244141 8.49988C-0.000244141 12.9182 3.58148 16.4999 7.99976 16.4999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 8.50006H16.0002C16.0002 7.77799 15.9039 7.07849 15.7246 6.41309H7.65234V8.50006Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 4.3261H14.826C14.3363 3.52698 13.7101 2.82064 12.98 2.23914H7.65234V4.3261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00014 16.5C9.88292 16.5 11.6135 15.8492 12.98 14.7609H3.02026C4.38683 15.8492 6.11736 16.5 8.00014 16.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17423 12.6739H14.8259C15.219 12.0324 15.5239 11.3311 15.7244 10.5869H0.275635C0.476166 11.3311 0.781072 12.0324 1.17423 12.6739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70551 1.74919H4.43454L3.75641 2.24185L4.01544 3.039L3.33735 2.54635L2.65926 3.039L2.88301 2.35035C2.28594 2.84769 1.76263 3.43038 1.33138 4.07963H1.56497L1.13332 4.39322C1.06607 4.50541 1.00157 4.61938 0.939756 4.73503L1.14588 5.36944L0.761318 5.09003C0.665725 5.29257 0.578287 5.49966 0.499693 5.71107L0.726787 6.41007H1.56497L0.88685 6.90272L1.14588 7.69988L0.467787 7.20722L0.0615996 7.50235C0.0209434 7.82916 -0.000244141 8.16203 -0.000244141 8.49988H7.99976C7.99976 4.08163 7.99976 3.56075 7.99976 0.499878C6.41938 0.499878 4.94616 0.958315 3.70551 1.74919ZM4.01544 7.69988L3.33735 7.20722L2.65926 7.69988L2.91829 6.90272L2.24016 6.41007H3.07835L3.33735 5.61291L3.59635 6.41007H4.43454L3.75641 6.90272L4.01544 7.69988ZM3.75641 4.57228L4.01544 5.36944L3.33735 4.87678L2.65926 5.36944L2.91829 4.57228L2.24016 4.07963H3.07835L3.33735 3.28247L3.59635 4.07963H4.43454L3.75641 4.57228ZM6.88501 7.69988L6.20691 7.20722L5.52882 7.69988L5.78785 6.90272L5.10972 6.41007H5.94791L6.20691 5.61291L6.46591 6.41007H7.3041L6.62597 6.90272L6.88501 7.69988ZM6.62597 4.57228L6.88501 5.36944L6.20691 4.87678L5.52882 5.36944L5.78785 4.57228L5.10972 4.07963H5.94791L6.20691 3.28247L6.46591 4.07963H7.3041L6.62597 4.57228ZM6.62597 2.24185L6.88501 3.039L6.20691 2.54635L5.52882 3.039L5.78785 2.24185L5.10972 1.74919H5.94791L6.20691 0.952034L6.46591 1.74919H7.3041L6.62597 2.24185Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7773_5248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.cdddda25d6b57191d7a8204935d0a244.svg";
export { ForwardRef as ReactComponent };